import React from "react";
import styled from "styled-components";

const PricingSection = () => {
  return (
    <PricingWrapper>
      <h2>Our Pricing Plans</h2>
      <p className="pricing-subtitle">
        Choose a plan that fits your needs — simple, transparent, and affordable.
      </p>

      <div className="pricing-cards">
        {/* Launch Plan */}
        <div className="pricing-card">
          <h3>Launch</h3>
          <p className="price">Free</p>
          <ul>
            <li>✔️ For Individuals Launching Their Products in small scale</li>
            <li>✔️ List their products in gift to Inspire</li>
            <li>✔️ 2% per transaction</li>
            <li>✔️ Standard Support</li>
            <li>✔️ Customer Portal For Subscription Management</li>
          </ul>
        </div>

        {/* Pro Plan */}
        <div className="pricing-card featured">
          <h3>Pro</h3>
          <p className="price">
            ₹499<span>/month</span>
          </p>
          <ul>
            <li>✔️ All Starter features</li>
            <li>✔️ API & CRM Integration</li>
            <li>✔️ Priority support</li>
            <li>✔️ Up to 5 users</li>
          </ul>
        </div>

        {/* Enterprise Plan */}
        <div className="pricing-card">
          <h3>Enterprise</h3>
          <p className="price">
            ₹999<span>/month</span>
          </p>
          <ul>
            <li>✔️ All Pro features</li>
            <li>✔️ Dedicated account manager</li>
            <li>✔️ Custom integrations</li>
            <li>✔️ Unlimited users</li>
          </ul>
        </div>
      </div>
    </PricingWrapper>
  );
};

export default PricingSection;

/* ------------------ STYLED COMPONENTS ------------------ */

const PricingWrapper = styled.section`
  background: #fff;
  text-align: center;
  padding: 80px 20px;

  h2 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 10px;
  }

  .pricing-subtitle {
    color: #666;
    margin-bottom: 50px;
    font-size: 1.1rem;
  }

  .pricing-cards {
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
  }

  .pricing-card {
    background: #f8f9fa;
    border-radius: 15px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    width: 300px;
    padding: 30px 20px;
    transition: all 0.3s ease;
    color: #333;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
  }

  .pricing-card.featured {
    background: linear-gradient(135deg, #80deea, #f48fb1);
    color: #fff;
    transform: scale(1.05);
  }

  .pricing-card h3 {
    margin-bottom: 10px;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .pricing-card .price {
    font-size: 2rem;
    margin: 15px 0;
    font-weight: bold;
    color: inherit;
  }

  .pricing-card .price span {
    font-size: 1rem;
    color: #555;
  }

  .pricing-card.featured .price span {
    color: #fff;
  }

  .pricing-card ul {
    list-style: none;
    padding: 0;
    margin: 20px 0;
    text-align: left;
  }

  .pricing-card ul li {
    margin: 10px 0;
    font-size: 0.95rem;
    color: inherit;
  }

  @media (max-width: 768px) {
    .pricing-cards {
      flex-direction: column;
      align-items: center;
    }

    .pricing-card {
      width: 90%;
      max-width: 350px;
    }
  }
`;
